import { atom } from 'recoil';

export const maintenanceTypesReloadListState = atom<boolean>({
  key: 'app.maintenanceTypes.reload',
  default: false,
});

export const maintenanceTypesFiltersState = atom<{
  page: number;
  search: string;
}>({
  key: 'app.maintenanceTypes.filters',
  default: {
    page: 1,
    search: '',
  },
});
